import { useState } from 'react';
import { 
  Typography, 
  Box, 
  Button, 
  Grid, 
  Card, 
  CardContent, 
  Avatar,
  Container,
  Tabs,
  Tab
} from '@mui/material';
import {
  Groups,
  AccessTime,
  EmojiEvents,
  Timeline
} from '@mui/icons-material';

const AboutUs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Company timeline data
  const timeline = [
    {
      year: '2023',
      title: 'Series A Funding',
      description: 'Successfully raised $10M to accelerate product development and market expansion'
    },
    {
      year: '2022',
      title: 'Beta Launch',
      description: 'Successfully launched beta version with 100+ early adopters'
    },
    {
      year: '2021',
      title: 'Company Founded',
      description: 'Started with a vision to revolutionize hiring through AI'
    }
  ];

  // Leadership team data
  const leaders = [
    {
      name: 'Sarah Johnson',
      role: 'CEO & Co-founder',
      bio: 'Former Head of AI at TechGiant, PhD in Machine Learning from Stanford',
      image: '/api/placeholder/100/100'
    },
    {
      name: 'Michael Chen',
      role: 'CTO & Co-founder',
      bio: '15+ years in AI and recruiting tech, Previously led engineering at RecruitTech',
      image: '/api/placeholder/100/100'
    }
  ];

  // Awards and recognition
  const awards = [
    'HR Tech Innovation Award 2023',
    'Forbes 30 Under 30 - Enterprise Technology',
    'Best AI Startup - TechCrunch Disrupt'
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Hero Section */}

      {/* Tabs Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange} 
          centered
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Mission" icon={<Groups />} iconPosition="start" />
          {/* <Tab label="Timeline" icon={<Timeline />} iconPosition="start" />
          <Tab label="Leadership" icon={<Groups />} iconPosition="start" />
          <Tab label="Recognition" icon={<EmojiEvents />} iconPosition="start" /> */}
        </Tabs>
      </Box>

      {/* Content Sections */}
      <Box mt={4}>
        {/* Mission Section */}
        {activeTab === 0 && (
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h4" gutterBottom>
                Our Mission
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
              "Our mission is to transform the hiring process by empowering businesses with an intelligent, human-like AI interviewer that automates initial interviews seamlessly. Acting as the first filter, our AI ensures efficiency, accuracy, and a natural interview experience—helping companies identify top talent faster while saving time and resources."
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
              <Groups sx={{ fontSize: 200, color: 'primary.main' }} />
            </Grid>
          </Grid>
        )}

        {/* Timeline Section */}
        {activeTab === 1 && (
          <Box>
            <Typography variant="h3" textAlign="center" gutterBottom>
              Our Journey
            </Typography>
            <Box sx={{ mt: 4 }}>
              {timeline.map((event, index) => (
                <Card key={index} sx={{ mb: 3, boxShadow: 2 }}>
                  <CardContent>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item>
                        <AccessTime color="primary" sx={{ fontSize: 40 }} />
                      </Grid>
                      <Grid item xs>
                        <Typography variant="h6" gutterBottom>
                          {event.year} - {event.title}
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                          {event.description}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Box>
        )}

        {/* Leadership Section */}
        {activeTab === 2 && (
          <Box>
            <Typography variant="h3" textAlign="center" gutterBottom>
              Leadership Team
            </Typography>
            <Grid container spacing={4}>
              {leaders.map((leader, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <Card sx={{ height: '100%', boxShadow: 3 }}>
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item>
                          <Avatar
                            src={leader.image}
                            alt={leader.name}
                            sx={{ width: 100, height: 100 }}
                          />
                        </Grid>
                        <Grid item xs>
                          <Typography variant="h5" gutterBottom>
                            {leader.name}
                          </Typography>
                          <Typography variant="subtitle1" color="primary" gutterBottom>
                            {leader.role}
                          </Typography>
                          <Typography variant="body1" color="text.secondary">
                            {leader.bio}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}

        {/* Recognition Section */}
        {activeTab === 3 && (
          <Box>
            <Typography variant="h3" textAlign="center" gutterBottom>
              Awards & Recognition
            </Typography>
            <Grid container spacing={4}>
              {awards.map((award, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Card sx={{ height: '100%', textAlign: 'center', boxShadow: 3 }}>
                    <CardContent>
                      <EmojiEvents color="primary" sx={{ fontSize: 60, mb: 2 }} />
                      <Typography variant="h6">
                        {award}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default AboutUs;